import { useSelectorToQueryParam } from '../shared/useSelectorToQueryParam'

import type { CheckBoxNode } from '~/core/ts/entity/CheckBoxNode'

export function useMultiSelectorToQueryParam(
  label: string,
  options: globalThis.Ref<Array<CheckBoxNode>>
) {
  const multiOptions = options

  const {
    optionSelected,
    pushQueryParam,
  } = useSelectorToQueryParam({
    label,
    defaultValue: ''
  })

  const optionsSelectedIDs = computed(() => {
    if (!optionSelected.value.value) {
      return []
    }

    return optionSelected.value.value.split(',')
  })

  const optionsSelected = computed(() => {
    const ids = optionsSelectedIDs.value

    const selectedOptions = []
    for (const id of ids) {
      for (const category of multiOptions.value) {
        if (category.id === id) {
          selectedOptions.push(category)
        }
      }
    }

    return selectedOptions
  })


  function onMultiPromoInput(data: Array<CheckBoxNode>) {
    multiOptions.value = data

    const selectedIndices = multiOptions.value
      .map((checkNode) => {
        if (checkNode.value) {
          return checkNode.id
        }

        return null
      })
      .filter((id) => !!id)

    pushQueryParam(selectedIndices.join(','))
  }

  const firstLoad = ref(true)

  onMounted(() => {
    setTimeout(() => {
      // Se pillan los parámetros de la URL y se actualiza el 'multiOptions'
      //   con las opciones que están activadas.
      if (firstLoad.value) {
        firstLoad.value = false

        if (optionSelected.value.value) {
          const ids = optionSelected.value.value.split(',')

          multiOptions.value = multiOptions.value
            .map((option) => {
              if (ids.includes(option.id)) {
                option.value = true
              }

              return option
            })
            // NOTE: antes se ordenaba poniendo arriba los que están marcados
        }
      }
    }, 100)
  })

  return {
    optionsSelectedIDs,
    optionsSelected,
    onMultiPromoInput,
  }
}
